import { render, staticRenderFns } from "./CategoryResume.vue?vue&type=template&id=041acab8&scoped=true&"
import script from "./CategoryResume.vue?vue&type=script&lang=js&"
export * from "./CategoryResume.vue?vue&type=script&lang=js&"
import style0 from "./CategoryResume.vue?vue&type=style&index=0&id=041acab8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041acab8",
  null
  
)

export default component.exports